module.exports = require('./lib/index').default;


// WEBPACK FOOTER //
// ./node_modules/axios-retry/index.js